import React, { useState } from "react";
import { SportEventCompetitor } from "../Timeline/Types";
import { TeamFullName, TeamIcon, TeamInfoContainer } from "./TeamInfo.styles";
import { UsersIcon } from "@icons/UsersIcon";
import { TeamIconContainer } from "./GameTimelineHeader.styles";

export function TeamInfo({
    teamData,
    reversed = false,
}: {
    teamData: SportEventCompetitor | undefined;
    reversed?: boolean;
}) {
    const [showFallback, setShowFallback] = useState<boolean>(false);
    return (
        <TeamInfoContainer
            style={{
                flexDirection: reversed ? "row-reverse" : "row",
            }}
        >
            <TeamFullName>{teamData?.name}</TeamFullName>
            <TeamIconContainer>
                <TeamIcon
                    src={teamData?.tipgameLogo}
                    onError={() => setShowFallback(true)}
                />
                {showFallback && (
                    <UsersIcon color="var(--community-color-light-steal-blue)" />
                )}
            </TeamIconContainer>
        </TeamInfoContainer>
    );
}
